<template>
  <div class="psPatientStatus">
    <el-button
      round
      :type="isActive ? 'danger' : 'success'"
      :icon="isActive ? 'el-icon-circle-close' : 'el-icon-circle-check'"
      :disabled="!editionMode || !patient.patientId"
      @click="openDialog"
      >{{ actionLabel }}</el-button
    >

    <el-dialog
      :title="actionLabel"
      :visible="dialogPatientStatus"
      :width="isMobile == true ? '90%' : '55%'"
      @close="closeDialog"
    >
      <div class="row" v-if="dialogPatientStatus">
        <div class="column w-33">
          <div class="label">Estado actual</div>
          <div
            class="data statusText"
            :class="isActive ? 'statusActive' : 'statusInactive'"
          >
            {{ isActive ? "Activo" : "Inactivo" }}
          </div>
        </div>
        <div class="column w-33">
          <div class="label">Fecha</div>
          <el-date-picker
            :value="patientStatus.date"
            type="date"
            placeholder="Seleccione una fecha"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            :default-value="new Date()"
            :clearable="false"
            @input="changeProperty($event, 'date')"
          ></el-date-picker>
        </div>
        <div class="column w-33">
          <div class="label">Peso actual</div>
          <el-input-number
            :value="patientStatus.weight"
            :min="0"
            :precision="1"
            :controls="false"
            @input="changeProperty($event, 'weight')"
            @focus="selectWeight"
            ref="weight"
          ></el-input-number>
        </div>
      </div>

      <div class="row" v-if="dialogPatientStatus">
        <div class="column w-50">
          <div class="label">Grupo</div>
          <div class="data">{{ groupDescription || "-" }}</div>
        </div>
        <div class="column w-50">
          <div class="label">Fase</div>
          <div class="data">{{ phaseDescription || "-" }}</div>
        </div>
      </div>

      <div class="row" v-if="dialogPatientStatus">
        <div class="column w-100">
          <div class="label">Notas</div>
          <el-input
            type="textarea"
            :rows="3"
            :value="patientStatus.notes"
            placeholder="Ingrese notas"
            maxlength="500"
            show-word-limit
            @input="changeProperty($event, 'notes')"
          ></el-input>
        </div>
      </div>

      <div class="row rowTitle">Histórico de altas y bajas</div>
      <el-table
        :data="patientStatusHistory"
        size="mini"
        max-height="220"
        empty-text="Sin movimientos"
      >
        <el-table-column label="Cambio de estado" width="140">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="scope.row.status == 'alta' ? 'success' : 'danger'"
              >{{ scope.row.status | textCapitalize }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="Fecha" width="110">
          <template slot-scope="scope">{{   (scope.row.date) }}</template>
        </el-table-column>
        <el-table-column label="Peso" width="80">
          <template slot-scope="scope">{{
            scope.row.weight | numberOneDecimal
          }}</template>
        </el-table-column>
        <el-table-column
          prop="group"
          label="Grupo"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="notes"
          label="Notas"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>

      <span slot="footer">
        <el-button round @click="closeDialog" :disabled="loading"
          >Cancelar</el-button
        >
        <el-button
          round
          :type="isActive ? 'danger' : 'success'"
          :disabled="loading"
          :loading="loading"
          @click="save"
          >{{ actionLabel }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { formatDateOnlyDDMMYYYY } from "@/services/utils";

export default {
  name: "PsPatientStatus",
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState(["isMobile"]),
    ...mapState("patients", [
      "editionMode",
      "patient",
      "patientStatus",
      "dialogPatientStatus"
    ]),
    isActive() {
      return this.patient.active == true || this.patient.active == 1;
    },
    actionLabel() {
      return this.isActive ? "Dar de baja" : "Dar de alta";
    },
    groupDescription() {
      if (this.patient.group && this.patient.group.groupDescription) {
        return this.patient.group.groupDescription;
      }
      return this.patient.groupDescription ? this.patient.groupDescription : "";
    },
    phaseDescription() {
      return this.patient.group && this.patient.group.phaseDescription
        ? this.patient.group.phaseDescription
        : "";
    },
    patientStatusHistory() {
      return this.patient.patientStatus ? this.patient.patientStatus : [];
    }
  },
  methods: {
    ...mapMutations("patients", [
      "PATIENTS_PATIENT_STATUS",
      "PATIENTS_PATIENT_STATUS_PROP",
      "PATIENTS_DIALOG_PATIENT_STATUS"
    ]),
    ...mapActions("patients", ["savePatientStatusHTTP", "getPatientHTTP"]),
    openDialog() {
      this.PATIENTS_PATIENT_STATUS({});
      this.PATIENTS_DIALOG_PATIENT_STATUS(true);
    },
    closeDialog() {
      this.PATIENTS_DIALOG_PATIENT_STATUS(false);
      this.PATIENTS_PATIENT_STATUS({});
    },
    changeProperty(value, property) {
      this.PATIENTS_PATIENT_STATUS_PROP({ property, value });
    },
    formatDate(value) {
      return formatDateOnlyDDMMYYYY(value);
    },
    selectWeight() {
      this.$refs.weight.select();
    },
    async save() {
      try {
        this.loading = true;
        const message = await this.savePatientStatusHTTP();
        await this.getPatientHTTP(this.$route.params["patientId"]);
        this.$message({ message, type: "success" });
        this.closeDialog();
      } catch (err) {
        this.$message({
          message:
            err.response && err.response.data.err
              ? err.response.data.err.details
              : "Error al registrar el movimiento. Inténtelo nuevamente",
          type: "error"
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.row {
  width: 100%;
}

.rowTitle {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.statusText {
  font-weight: 500;
  line-height: 40px;
}

.statusActive {
  color: #67c23a;
}

.statusInactive {
  color: #f56c6c;
}

.data {
  line-height: 40px;
}

.el-input-number,
.el-date-editor,
.el-textarea {
  width: 100%;
}

.row > .column:last-child {
  margin-right: 0;
}

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
  .row {
    flex-direction: column;
  }

  .row > .column {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }
}
</style>
